import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-fcb3496c")
const _hoisted_1 = {
  id: "kt_content_container",
  class: "container-xxl pap-flex pt-10 pb-20"
}
const _hoisted_2 = { class: "card card-flush w-100 p-0" }
const _hoisted_3 = { class: "card-body p-6 py-8 d-flex justify-content-between align-items-center shadow-bottom" }
const _hoisted_4 = { class: "w-max-con" }
const _hoisted_5 = { class: "fw-bolder m-0 d-flex fs-2" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Picking Job # ")
const _hoisted_7 = { class: "fw-bolder m-0 ms-4 text-black-50 fs-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", { class: "m-0 mt-2 fw-bold fs-6 d-flex text-black-50" }, [
  /*#__PURE__*/_createTextVNode(" Created: "),
  /*#__PURE__*/_createElementVNode("h1", { class: "m-0 ms-2 fw-bold fs-6 d-flex text-black" }, " 18, Mar 2022 ")
], -1)
const _hoisted_9 = { class: "w-max-con h-100" }
const _hoisted_10 = { class: "w-500px px-8 d-flex justify-content-between" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", { class: "m-0" }, " title ", -1)
const _hoisted_12 = { class: "d-flex m-0" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" / 40 ")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "w-500px py-1 px-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-100 h-7p5 rounded progress-bg" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h-100 rounded progress-fg" })
  ])
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-light p-8" })
], -1)
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"table-footer p-6 py-10 border-top d-flex flex-row justify-content-between align-items-center max-w-100\" data-v-fcb3496c><div class=\"w-150px\" data-v-fcb3496c>.</div><div class=\"w-150px\" data-v-fcb3496c>.</div><div class=\"w-max-con d-block\" data-v-fcb3496c><p class=\"fs-5 fw-bold\" data-v-fcb3496c>Comment:</p><div class=\"p-2\" data-v-fcb3496c><p data-v-fcb3496c>Placeholder placeholder placeholder placeholder placeholder placeholder</p></div></div><div class=\"w-max-con d-block\" data-v-fcb3496c><p class=\"fs-5 fw-bold\" data-v-fcb3496c>Picking Tags:</p><div class=\"p-2\" data-v-fcb3496c><p data-v-fcb3496c>Placeholder placeholder placeholder placeholder placeholder placeholder</p></div></div><div class=\"w-max-con d-block\" data-v-fcb3496c></div><div class=\"w-max-con d-block\" data-v-fcb3496c><p class=\"fs-5 fw-bold\" data-v-fcb3496c>Orders:</p><div class=\"p-2\" data-v-fcb3496c><a data-v-fcb3496c>Placeholder placeholder placeholder placeholder placeholder placeholder</a></div></div><div class=\"w-max-con d-block\" data-v-fcb3496c></div><div class=\"w-max-con\" data-v-fcb3496c><button type=\"button\" class=\"btn btn-blue dropdown-toggle\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\" data-v-fcb3496c> Action </button><ul class=\"dropdown-menu\" data-v-fcb3496c></ul></div></div>", 1)
const _hoisted_17 = { class: "card card-flush w-100 p-0" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "card-header px-6 py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0 d-flex" }, " Picking items ")
  ])
], -1)
const _hoisted_19 = { class: "card-body p-6" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<button class=\"btn px-4 py-2 btn-success\" data-v-fcb3496c>Complete</button><button class=\"btn px-4 py-2 btn-light\" data-v-fcb3496c>Clear</button><button class=\"btn px-4 py-2 btn-light\" data-v-fcb3496c>+ Add</button><button class=\"btn px-4 py-2 btn-light\" data-v-fcb3496c>Show</button><button class=\"btn px-4 py-2 btn-light\" data-v-fcb3496c>Open</button><button class=\"btn px-4 py-2 btn-success fs-6 fw-bold\" data-v-fcb3496c>Start</button><input type=\"text\" class=\"form-control input-bg text-start\" value=\"1\" data-v-fcb3496c>", 7)
const _hoisted_27 = { class: "w-150px" }
const _hoisted_28 = { class: "w-150px" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "table-footer p-6 d-flex border-top" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn px-4 py-2 btn-light" }, "Cancel"),
  /*#__PURE__*/_createElementVNode("button", { class: "btn px-4 py-2 ms-auto btn-blue" }, "Start Scanning"),
  /*#__PURE__*/_createElementVNode("button", { class: "btn px-4 py-2 ms-6 btn-warning" }, "Partial Picking")
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Countup = _resolveComponent("Countup")!
  const _component_TableTag = _resolveComponent("TableTag")!
  const _component_TableStatus = _resolveComponent("TableStatus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.ID.replaceAll(":", '')), 1)
          ]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("h5", _hoisted_12, [
              _createVNode(_component_Countup, {
                end: 0,
                isOffset: true
              }),
              _hoisted_13
            ])
          ]),
          _hoisted_14
        ]),
        _hoisted_15
      ]),
      _hoisted_16
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_TableTag, { tag: 1 })
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_TableStatus, { status: 3 })
        ]),
        _hoisted_29
      ]),
      _hoisted_30
    ])
  ]))
}